import Layout from "../../../components/layout";
import Breadcrumb from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import { getPages } from "../../privacyPolicy/api";
import MarkdownIt from "markdown-it";
import aboutbnr from "../../../assets/images/aboutbnr.png";
import logo from "../../../assets/images/logo.svg";
import logoace from "../../../assets/images/logoace.svg";
import phn from "../../../assets/images/phn.png";
import googleplay from "../../../assets/images/googleplay.svg";
import appstore from "../../../assets/images/appstore.svg";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const [aboutPage, setAboutPage] = useState<string>("");

  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });

  useEffect(() => {
    getPages({ type: 4 }).then((res) => {
      setAboutPage(res.data.data.content);
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <meta
        name="description"
        content="Learn about Commbitz, a leader in eSIM solutions. Connecting travelers in over 190+ countries with reliable, affordable, and seamless digital roaming."
      />
      <title>About Commbitz | Simplifying Global Connectivity</title>
      <Breadcrumb />
      {/* <div className="newabout">
        <div className="container">
         
        </div>
      </div> */}
      <div className="container about-content">
        <div className="row align-items-center mt-5">
          <div className="col-lg-6">
            <h3>About Us</h3>
            <div
              className="text-dark mb-5"
              dangerouslySetInnerHTML={{
                __html: mdParser.render(aboutPage),
              }}
            />
          </div>

          <div className="col-lg-6">
            <div className="newaboutbanner">
              <img src={aboutbnr} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="phnApp">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="phnappleft">
                {/* <img src={logo} alt="" /> */}
                <Link className={`nav-Link`} to="/"> 
                  <i className="pe-3 border-end broder-light border-2">
                    <img width="120" height="36" src={logo} alt="Commbitz logo" /></i>
                  <i>
                    <img width="120" height="46" src={logoace} alt="Commbitz logo" /></i>
                  </Link>
                <h5 className="mt-4">
                  Stay Connected, Stay Free With Commbitz, you’re not just
                  getting an eSIM—you’re unlocking a world of effortless
                  connectivity. Travel anywhere, anytime, without worrying about
                  staying online
                </h5>
                <div className="aboutapp">
                  <p>
                    Download the Commbitz app today on the App Store or Google
                    Play, and experience the future of global connectivity!
                  </p>
                  <div className="appbtn">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.commbitz"
                      target="_blank"
                    >
                      <img src={googleplay} alt="" />
                    </a>
                    <a
                      href="https://apps.apple.com/in/app/commbitz-e-sim/id6572300745"
                      target="_blank"
                    >
                      <img src={appstore} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="phnappright pt-5">
                <img className="img-fluid" src={phn} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;
